export default __webpack_public_path__ + "static/media/like.6b6b4260.svg";